export default __webpack_public_path__ + "static/Hack-ZeroSlash-Regular-f67447de5dc6604f538786bd55ac6019.woff";